// Mantis Toast Utility - Zentrale Toast-Verwaltung

let toastContainer = null;
let toastIdCounter = 0;

// Container für Toasts erstellen
const createToastContainer = () => {
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'mantis-toast-container';
    toastContainer.style.position = 'fixed';
    toastContainer.style.top = '0';
    toastContainer.style.right = '0';
    toastContainer.style.zIndex = '10000';
    toastContainer.style.pointerEvents = 'none';
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
};

// Toast erstellen und anzeigen
const showMantisToast = (message, type = 'success', duration = 3000) => {
  const container = createToastContainer();
  const toastId = `mantis-toast-${++toastIdCounter}`;
  
  // Toast-Element erstellen
  const toast = document.createElement('div');
  toast.id = toastId;
  toast.className = `mantis-toast ${type}`;
  
  // Icon basierend auf Typ
  const getIcon = (toastType) => {
    switch (toastType) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'warning': return '⚠';
      case 'info': return 'ℹ';
      default: return '✓';
    }
  };
  
  toast.innerHTML = `
    <div class="mantis-toast-content">
      <div class="mantis-toast-icon">${getIcon(type)}</div>
      <span>${message}</span>
    </div>
  `;
  
  // Position berechnen (Toasts stapeln)
  const existingToasts = container.children.length;
  const topOffset = 20 + (existingToasts * 70);
  toast.style.top = `${topOffset}px`;
  
  // Toast hinzufügen
  container.appendChild(toast);
  
  // Auto-remove nach duration
  setTimeout(() => {
    if (toast && toast.parentNode) {
      toast.style.animation = 'mantisToastSlideOut 0.3s cubic-bezier(0.4, 0, 1, 1) forwards';
      setTimeout(() => {
        if (toast && toast.parentNode) {
          container.removeChild(toast);
          // Nachfolgende Toasts neu positionieren
          repositionToasts();
        }
      }, 300);
    }
  }, duration);
  
  return toastId;
};

// Toasts neu positionieren nach dem Entfernen
const repositionToasts = () => {
  if (!toastContainer) return;
  
  Array.from(toastContainer.children).forEach((toast, index) => {
    const topOffset = 20 + (index * 70);
    toast.style.top = `${topOffset}px`;
    toast.style.transition = 'top 0.3s ease';
  });
};

// Alle Toasts entfernen
const clearAllToasts = () => {
  if (toastContainer) {
    while (toastContainer.firstChild) {
      toastContainer.removeChild(toastContainer.firstChild);
    }
  }
};

// Spezifische Toast-Funktionen
export const showSuccessToast = (message, duration = 3000) => {
  return showMantisToast(message, 'success', duration);
};

export const showErrorToast = (message, duration = 4000) => {
  return showMantisToast(message, 'error', duration);
};

export const showWarningToast = (message, duration = 3500) => {
  return showMantisToast(message, 'warning', duration);
};

export const showInfoToast = (message, duration = 3000) => {
  return showMantisToast(message, 'info', duration);
};

// Legacy-Support für bestehende Implementierungen
export const showToast = showSuccessToast;

export { clearAllToasts, showMantisToast };
export default {
  success: showSuccessToast,
  error: showErrorToast,
  warning: showWarningToast,
  info: showInfoToast,
  clear: clearAllToasts
}; 